// 语言代码映射
export const isoCodeMap = {
  zh: 'zhCN',
  'zh-cn': 'zhCN',
  'zh-tw': 'zhTW',
}

/**
 * 或设备语言转换为语言代码
 * @returns 语言代码
 */
export const geLangCodeByDevice = (language: string = navigator.language) => {
  if (isoCodeMap[language]) return isoCodeMap[language]
  return language.split('-')[0]
}

/**
 * 获取页面语言代码
 * @param useDefault 没获取到是否返回默认语言
 * @returns
 */
export const getPageLangCode = (useDefault = true) => {
  const urlParams = new URLSearchParams(window.location.search)
  let language = urlParams.get('language') || urlParams.get('lang')
  if (!useDefault) return language

  if (!language) {
    language = geLangCodeByDevice()
  }

  return isoCodeMap[language.toLowerCase()] || language
}

// IETF 语言代码映射
const ietfLangCodeMap = {
  zh: 'zh-CN',
  zhCN: 'zh-CN',
  zhTW: 'zh-TW',
  en: 'en-US',
  ja: 'ja-JP',
  ar: 'ar-AE',
  ko: 'ko-KR',
  de: 'de-DE',
  fr: 'fr-FR',
  ru: 'ru-RU',
  es: 'es-ES',
  pt: 'pt-PT',
  th: 'th-TH',
  indo: 'id-ID',
  vi: 'vi-VN',
  tr: 'tr-TR',
  it: 'it-IT',
}

/**
 * 将语言代码转换为IETF语言代码
 * @param lang 语言代码
 * @returns IETF语言代码
 */
export const toIETFLangCode = (lang: string) => {
  return ietfLangCodeMap[lang] || 'en-US'
}

/** 语言代码映射为语言名称 */
const languageWordMap = {
  zhCN: '简体中文',
  zhTW: '繁體中文',
  en: 'English',
  ja: '日本語',
}

/**
 * 将语言代码转换为语言名称
 * @param lang 语言代码
 * @returns 语言名称
 */
export const toLanguageWord = (code: string) => {
  return languageWordMap[code]
}
